"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPersonTypeToMangopayPersonType = transformPersonTypeToMangopayPersonType;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformPersonTypeToMangopayPersonType(type) {
    switch (type) {
        case "NATURAL":
            return legacy_enums_1.MangopayPersonType.Natural;
        case "LEGAL":
            return legacy_enums_1.MangopayPersonType.Legal;
        default:
            throw new Error(`Unknown person type: ${type}`);
    }
}
//# sourceMappingURL=transformPersonTypeToMangopayPersonType.js.map